function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 4.74999C5.66848 4.74999 5.35054 4.88168 5.11612 5.1161C4.8817 5.35053 4.75 5.66847 4.75 5.99999V20C4.75 20.3315 4.8817 20.6495 5.11612 20.8839C5.35054 21.1183 5.66848 21.25 6 21.25H18C18.3315 21.25 18.6495 21.1183 18.8839 20.8839C19.1183 20.6495 19.25 20.3315 19.25 20V5.99999C19.25 5.66847 19.1183 5.35053 18.8839 5.1161C18.6495 4.88168 18.3315 4.74999 18 4.74999H16C15.5858 4.74999 15.25 4.4142 15.25 3.99999C15.25 3.58577 15.5858 3.24999 16 3.24999H18C18.7293 3.24999 19.4288 3.53972 19.9445 4.05544C20.4603 4.57117 20.75 5.27064 20.75 5.99999V20C20.75 20.7293 20.4603 21.4288 19.9445 21.9445C19.4288 22.4603 18.7293 22.75 18 22.75H6C5.27065 22.75 4.57118 22.4603 4.05546 21.9445C3.53973 21.4288 3.25 20.7293 3.25 20V5.99999C3.25 5.27064 3.53973 4.57117 4.05546 4.05544C4.57118 3.53972 5.27065 3.24999 6 3.24999H8C8.41421 3.24999 8.75 3.58577 8.75 3.99999C8.75 4.4142 8.41421 4.74999 8 4.74999H6Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 2.75001C8.86193 2.75001 8.75 2.86194 8.75 3.00001V5.00001C8.75 5.13808 8.86193 5.25001 9 5.25001H15C15.1381 5.25001 15.25 5.13808 15.25 5.00001V3.00001C15.25 2.86194 15.1381 2.75001 15 2.75001H9ZM7.25 3.00001C7.25 2.03351 8.0335 1.25001 9 1.25001H15C15.9665 1.25001 16.75 2.03351 16.75 3.00001V5.00001C16.75 5.96651 15.9665 6.75001 15 6.75001H9C8.0335 6.75001 7.25 5.96651 7.25 5.00001V3.00001Z",
  fill: "currentColor"
});

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.fa59f9df.svg";
export { ForwardRef as ReactComponent };